import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { type LanguageCode, SUPPORTED_LANGS } from "@/i18n/constants";
import { useIsI18nEnabled } from "@/i18n/feature-flag";
import {
	rewriteLocaleInPath,
	stripLeadingLocale,
} from "./rewrite-locale-in-path";

const SUPPORTED = SUPPORTED_LANGS as readonly string[];

const useLocalizedHref = () => {
	const enabled = useIsI18nEnabled();
	const { i18n } = useTranslation();
	const language = i18n.language;

	return useCallback(
		(route: string) => {
			if (!enabled) return route;
			if (!SUPPORTED.includes(language)) return route;
			return rewriteLocaleInPath(route, language as LanguageCode);
		},
		[enabled, language],
	);
};

export { stripLeadingLocale, useLocalizedHref };
